<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle25')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle25') }}</h1>
    <p>{{ $t('artText25-1') }}</p>
    <img
      :src="`${staticUrl}/images/blog/Home_Design_App_Guide_Step_Into_Your_Dream.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText25-2') }}</h2>
    <p>{{ $t('artText25-3') }}</p>
    <p>{{ $t('artText25-4') }}</p>
    <h2>{{ $t('artText25-5') }}</h2>
    <p>{{ $t('artText25-6') }}</p>
    <ul>
      <li>
        <b>{{ li1[1] }} </b>
        {{ li1[2] }}
      </li>
      <li>
        <b>{{ li2[1] }} </b>
        {{ li2[2] }}
      </li>
      <li>
        <b>{{ li3[1] }} </b>
        {{ li3[2] }}
      </li>
    </ul>
    <img
      :src="`${staticUrl}/images/blog/Home_Design_App_Guide_Step_Into_Your_Dream_1.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText25-7') }}</h2>
    <p>{{ $t('artText25-8') }}</p>
    <ul>
      <li>
        <b>{{ li4[1] }} </b>
        {{ li4[2] }}
      </li>
      <li>
        <b>{{ li5[1] }} </b>
        {{ li5[2] }}
      </li>
      <li>
        <b>{{ li6[1] }} </b>
        {{ li6[2] }}
      </li>
    </ul>
    <h2>{{ $t('artText25-9') }}</h2>
    <p>{{ $t('artText25-10') }}</p>
    <h2>{{ $t('artText25-11') }}</h2>
    <p>{{ $t('artText25-12') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import {getTranslateBySpanTag} from '~/helpers/baseFunction';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle25')}`,
  ogTitle: `${t('artSeoTitle25')}`,
  description: `${t('artSeoDesc25')}`,
  ogDescription: `${t('artSeoDesc25')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});

const li1 = computed(() =>
  getTranslateBySpanTag(t('artText25-6-li-1')),
);
const li2 = computed(() =>
  getTranslateBySpanTag(t('artText25-6-li-2')),
);
const li3 = computed(() =>
  getTranslateBySpanTag(t('artText25-6-li-3')),
);

const li4 = computed(() =>
  getTranslateBySpanTag(t('artText25-8-li-1')),
);
const li5 = computed(() =>
  getTranslateBySpanTag(t('artText25-8-li-2')),
);
const li6 = computed(() =>
  getTranslateBySpanTag(t('artText25-8-li-3')),
);
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
